export { default as RetrieveProductKeySellingPointsQuery } from './RetrieveProductKeySellingPointsQuery';